import axios from "axios";
import {useChatSessions} from "@src/composables/useChatSessions";
import ChatSession from "@src/types/ChatSession";

const {newSession, pauseSession, finishSession, archiveSession} = useChatSessions()

class SessionService {
    async verifyStartConversation(costumer: string) {
        try {
            const response = await axios.get(
                '/operator/v4/start-conversation/verify',
                {
                    withCredentials: true,
                    params: {costumer}
                }
            )

            return response.data?.is_open === true
        } catch (error) {
            console.error('❌ Erro ao buscar sessão', error)
            return false
        }
    }

    async startConversation(phone: string, channel: string) {
        try {
            const response = await axios.post(
                '/operator/v4/sessions/start-conversation',
                {phone, channel},
                {withCredentials: true}
            )

            await newSession(response.data)

            return response.data.id
        } catch (error) {
            console.error('Erro ao criar nova sessão', error)
            return false
        }
    }

    async initSession(session: ChatSession | undefined) {
        try {
            if (!session) {
                return false
            }
            await axios.post('/operator/v4/sessions/init', {'session': session.id}, {withCredentials: true})
            return true
        } catch (error) {
            console.error('Erro ao iniciar sessão: ', error)
            return false
        }
    }

    async setSessionFixed(sessionId: number, is_fixed: boolean) {
        try {
            const {data} = await axios.patch(
                `/operator/v4/sessions/${sessionId}/fixed`,
                {is_fixed},
                {withCredentials: true}
            );

            return data as { id: number; is_fixed: boolean };
        } catch (error) {
            console.error("❌ Erro ao fixar/desafixar sessão", error);
            return false as const;
        }
    }

    async setSessionHasNewMessage(sessionId: number) {
        try {
            const {data} = await axios.patch(
                `/operator/v4/sessions/${sessionId}/set_has_new_messages`,
                {withCredentials: true}
            );

            return data
        } catch (error) {
            console.error("❌ Erro ao atualizar new message", error);
            return false as const;
        }
    }

    async bulkPauseSessions(sessions: number[]) {

        if (!sessions || sessions.length === 0) return false

        try {

            await Promise.all(
                sessions.map(id => pauseSession(id))
            )

            return true

        } catch (error) {
            console.error('❌ Erro no bulk pause', error)
            return false
        }
    }

    async bulkFinishSessions(sessions: number[]) {

        if (!sessions || sessions.length === 0) return false

        try {

            await Promise.all(
                sessions.map(id => finishSession(id))
            )

            return true

        } catch (error) {
            console.error('❌ Erro no bulk finish', error)
            return false
        }
    }

    async bulkArchiveSessions(sessions: number[], status: boolean) {

        if (!sessions || sessions.length === 0) return false

        try {

            await Promise.all(
                sessions.map(id => archiveSession(id, status))
            )

            return true

        } catch (error) {
            console.error('❌ Erro no bulk finish', error)
            return false
        }
    }

    async fetchHistoryPage(
        sessionId: string | number,
        page: number
    ) {
        const {data} = await axios.get(`/operator/v4/sessions/${sessionId}/history`, {
            params: {page, per_page: 20, order: 'desc'}
        });
        return data;
    }


}

export default new SessionService();
